export const ContactStore = [
  {
    type: "email",
    icon: "ic:outline-email",
    label: "Email Us",
    values: ["enquires@aurametal.com.np", "yuquan@aurametal.com.np"],
  },
  {
    type: "phone",
    icon: "tabler:phone",
    label: "Call Us",
    values: ["+977-9715159595", "+977-9715259595", "+977-9715559595"],
  },
  {
    type: "address",
    icon: "carbon:location",
    label: "Factory Address",
    values: [
      "Imadol, Mahalaxmi-02,",
      "Lalitpur, Nepal",
    ],
  },
  {
    type: "business-hours",
    icon: "tabler:clock",
    label: "Business Hours",
    values: ["Mon – Fri: 08:00 – 18:00 CST", "Sat: 09:00 – 14:00 CST"],
  },
];